const projects = [
  {
    id: "1",
    title: "1º Portifolio",
    subtitle: "Primeiro contato web",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/port1-2.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/port1-mob.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/skills/html.png?raw=true",
    github: "https://github.com/kelvynkhrystian/kelvynkhrystian.github.io",
    deploy: "https://github.com/kelvynkhrystian/kelvynkhrystian.github.io",
    category: "no",
    description:
      "Meu primeiro portilólio HTML e meu primeiro contato com o mundo web, nos links de repositório e deploy levam ao meu portifólio antes de ser feito em react e lá tem um vídeo demonstrando a evolução de todo processo a partir deste aqui",
    technologies: "HTML",
  },
  {
    id: "2",
    title: "Formulário",
    subtitle: "Um forms html sobre pets",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/forms1.png?raw=true",
    image2:
      "https://user-images.githubusercontent.com/94154348/191156276-a10b8c1b-719f-4fcd-abbf-c1842387d617.png",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/linke.png?raw=true",
    github: "https://github.com/kelvynkhrystian/formulario",
    deploy: "https://formulario-nine-orcin.vercel.app/",
    category: "no",
    description:
      "Revisar Forms e Validações Html, Html semântico e Css Flexbox, Responsividade (Mobile First, PC second), Git branchs e commits melhores",
    technologies: "HTML, CSS",
  },
  {
    id: "3",
    title: "Login Page",
    subtitle: "Uma página de login",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/login-page.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/login-page2.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/log.gif?raw=true",
    github: "https://github.com/kelvynkhrystian/login-page",
    deploy: "https://login-page-nine-mocha.vercel.app/",
    category: "no",
    description:
      "Simulação de criação de uma página simples de login de uma rede social (inexistente)",
    technologies:
      "Html Semântico, Forms, e algumas validações, Css Flexbox e criatividade ( e alguma animação css !!! ), Responsividade PC e Mobile, Google Fonts",
  },
  {
    id: "4",
    title: "Calculadora",
    subtitle: "Tema: One piece",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/calculadora.png?raw=true",
    image2:
      "https://user-images.githubusercontent.com/94154348/170815395-7352d6c2-970a-49aa-bf20-935212e39f1c.png",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/calc.png?raw=true",
    github: "https://github.com/kelvynkhrystian/calculadora",
    deploy: "https://calculadora-omega-two.vercel.app/",
    category: "js",
    description:
      "Treinando Abstração, HTML, CSS e JS, e ainda fiz o arquivo .APK por um programa na web que transforma html em apk.",
    technologies: "Html, Css, Javascript",
  },
  {
    id: "5",
    title: "Formulário 2",
    subtitle: "melhoria do formulário 1",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/forms2.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/forms22.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/forms222.png?raw=true",
    github: "https://github.com/kelvynkhrystian/formsJS",
    deploy: "https://forms-js.vercel.app/",
    category: "js",
    description:
      "A proposta é melhorar um forms que foi feito somente com html e css. Então o mesmo está sendo recriado adicionando o JS na sua composição, dando possibilidade para fazer melhores validações",
    technologies:
      "HTML, CSS, DOM, Forms, Eventos, Lógica JS, Bootstrap, Validações, Arrow Functions, Responsividade - Mobile First",
  },
  {
    id: "6",
    title: "To do List",
    subtitle: "Lista de tarefas funcional",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/to-do-list1.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/to-do-list22.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/to-do-list3.png?raw=true",
    github: "https://github.com/kelvynkhrystian/todolist",
    deploy: "https://todolist-eight-xi.vercel.app/index2.html",
    category: "js",
    description:
      "Uma lista de tarefas que vc pode atualizar, fechar e os itens continuarão salvos, com gifs de fundo, animações suaves nos botões e designer dark mode para não fritar os olhos!",
    technologies: "HTML5, CSS3, Javascript, Webstorage (LocalStorage)",
  },
  {
    id: "7",
    title: "Portifólio",
    subtitle: "Evolução",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/port21.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/port22.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/port2222.png?raw=true",
    github: "https://github.com/kelvynkhrystian/kelvynkhrystian.github.io",
    deploy: "https://kelvynkhrystian.github.io/",
    category: "js",
    description:
      "Utilizando conceitos de Html semântico, CSS flexbox, Eventos em JS e criatividade de ir testando o que achei interessante! guardei idéias em arquivos separados e organizei, pois em um início de jornada é sempre bom uma dose de motivação sincera ao ver que está crescendo aos poucos.",
    technologies: "HTML5, CSS3, Javascript",
  },
  {
    id: "8",
    title: "Casa de Câmbio",
    subtitle: "Cotação de Câmbio",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/cambio1.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/cambio2.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/cambio3.png?raw=true",
    github: "https://github.com/kelvynkhrystian/casaDeCambio",
    deploy: "https://casa-de-cambio-nine.vercel.app/",
    category: "js",
    description:
      "Um app de conversão de moedas! Retorna a busca de acordo com os dados colocados no campos! caso o usuário coloque um dado incorreto ou vazio é exibido um alerta de erro!",
    technologies:
      "HTML5, CSS3, JSES6 (Hofs, Await, Async,Fetch ), Responsividade, CSS Flexbox, Forms, Tratamento de erros, Biblioteca sweetalert2.",
  },
  {
    id: "9",
    title: "Shopping Cart",
    subtitle: "Carrinho de compras",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/shopping.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/shopping2.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/shopping6.png?raw=true",
    github: "https://github.com/kelvynkhrystian/shoppingCart",
    deploy: "https://shopping-zeta-jade.vercel.app/",
    category: "js",
    description:
      "Funcionalidades do carrinho: Adicionar e remover produtos, remover todos os produtos, contador do número de itens no carrinho, contador do valor total dos itens do carrinho e ao atualizar/fechar a página, os itens continuam salvos!",
    technologies:
      "Focando no estudo de: Responsividade, Flexbox, Webstorage (localStorage), API ( Mercado Livre), Js Assíncrono (FetchAPI, Async, Await), Hofs, ...",
  },
  {
    id: "10",
    title: "Lhama Password",
    subtitle: "Gerador de Senhas",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/lhama.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/lhama2.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/icons/lhama3.png?raw=true",
    github: "https://github.com/kelvynkhrystian/generate-password",
    deploy: "https://generate-password-six.vercel.app/",
    category: "react",
    description:
      "Um app com objetivo de criar senhas aleatórias e seguras com 16 caracteres. Sendo eles letras maiúsculas e minúsculas, números e simbolos.",
    technologies:
      "HTML5, CSS3, Javascript ES6, React, Styled Components, Bibliteca Copy-To-Clipboard e Biblioteca React-Tostify",
  },
  {
    id: "11",
    title: "KTunes",
    subtitle: "App de Músicas",
    image:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/khrystian-tunes-pc.png?raw=true",
    image2:
      "https://github.com/kelvynkhrystian/portifolio/blob/main/src/imgs/projects/mob-tunes.png?raw=true",
    icon: "https://github.com/kelvynkhrystian/khrystianTunes/blob/main/public/iconHeadfone.png?raw=true",
    github: "https://github.com/kelvynkhrystian/khrystianTunes",
    deploy: "https://khrystian-tunes.vercel.app/",
    category: "react",
    description: "Um app que busca músicas na api e consegue reproduzidas",
    technologies: "React, Css Modules, APIs Externas",
  },
];

export default projects;
